import React from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'

export default function CountryComp({ country, setCountry, countries }) {

    const handleChange = (event, newValue) => {
        setCountry(newValue !== null ? newValue : '')
    }

    return (
        <Autocomplete
            options={countries}
            getOptionLabel={(option) => option}
            value={country !== '' ? country : null}
            onChange={handleChange}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Country"
                    placeholder="Country..."
                    inputProps={{...params.inputProps, readOnly: false}}
                />
            )}
        />
    )
}
